export const PRODUCT_REQUEST= "PRODUCT_REQUEST";
export const PRODUCT_FAILURE= "PRODUCT_FAILURE";
//project
export const GET_PRODUCT_SUCCESS= "GET_PRODUCT_SUCCESS";
export const ADD_PROJECT_SUCCESS= "ADD_PROJECT_SUCCESS";




